import React from "react";

const G = "/assets/kiki/gallery";
const STRIP = [
  { src: `${G}/about-team-1.jpg`, caption: "Our faculty & mentors" },
  { src: `${G}/about-campus-1.jpg`, caption: "Students at the Gurugram campus" },
  { src: `${G}/about-team-2.jpg`, caption: "The Kiki team" },
  { src: `${G}/about-campus-2.jpg`, caption: "A growing community of learners" },
  { src: `${G}/about-team-3.jpg`, caption: "With our German training partners" },
  { src: `${G}/about-campus-3.jpg`, caption: "Life at Kiki Centre for Technology" },
  { src: `${G}/kiki-team-group.jpg`, caption: "One team, one mission" },
  { src: `${G}/campus-students-1.jpg`, caption: "25,000 sq.ft. training campus" },
];

// One slow editorial marquee — pauses on hover.
export default function AboutGalleryStrip() {
  const row = [...STRIP, ...STRIP];
  return (
    <section className="py-16 bg-white overflow-hidden" data-testid="about-gallery-strip">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mb-10">
        <p className="kicker mb-3">Life at Kiki</p>
        <h2 className="text-3xl font-bold text-[#0B2A6B]">Our people & our campus</h2>
        <p className="mt-3 text-slate-600 max-w-2xl leading-relaxed">
          A glimpse of the faculty, students and 25,000 sq.ft. campus at IMT Manesar, Gurugram.
        </p>
      </div>
      <div className="kiki-marquee group relative">
        <div className="kiki-marquee-track">
          {row.map((img, i) => (
            <figure
              key={`${img.src}-${i}`}
              className="relative mx-3 h-64 w-[22rem] shrink-0 overflow-hidden rounded-2xl shadow-sm ring-1 ring-black/5"
              data-testid={`about-strip-item-${i}`}
            >
              <img
                src={img.src}
                alt={img.caption}
                loading="lazy"
                className="h-full w-full object-cover"
              />
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0B2A6B]/85 to-transparent p-4 text-sm font-semibold text-white">
                {img.caption}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
